export const state = () => ({
  triggerChange: false,//是否是变更状态
  offline: false,//账户类型
  approvalIndex: 0,//只要是可能触发变更的地方，通过这个变量触发监听
})

export const mutations = {
  set_triggerChange(state, v) {
    state.triggerChange = v;
  },
  set_offline(state, v) {
    state.offline = v;
  },
  set_approvalIndex(state) {
    state.approvalIndex++
  }
}
export const actions = {

}
export default {
	namespaced: true,
	state,
	actions,
	mutations
}